module.exports = __webpack_public_path__ + "img/ico-changed-reply-yes-historic.61cf95f8.svg";